module.exports = __webpack_public_path__ + "img/te-search.a916e6f5.svg";